module.exports = __webpack_public_path__ + "exo-latin-200.6272ec972e113356a7ac.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-200.woff2
// module id = ../../../../typeface-exo/files/exo-latin-200.woff2
// module chunks = styles